import { InjectionToken } from '@angular/core';

export interface AppConfig {
  DST: {
    DatumX: string;
    DatumY: string;
    ProductBusinessKey: string;
  };
}

export const APP_CONFIG = new InjectionToken<AppConfig>('configuration');

const DEFAULT_APP_CONFIG: AppConfig = {
  DST: {
    DatumX: '2024-01-01T00:00:00.000',
    DatumY: '2024-01-29T00:00:00.000',
    ProductBusinessKey: 'LIBDST',
  },
};

export function getAppConfigWithDefaults(config?: Partial<AppConfig>): AppConfig {
  return { ...DEFAULT_APP_CONFIG, ...config } as AppConfig;
}
